import { Card, CardContent } from "../ui/card"
import { Skeleton } from "../ui/skeleton"

export function ContactListSkeleton({ count = 5 }: { count?: number }) {
  return (
    <>
      {Array.from({ length: count }).map((_, index) => (
        <Card key={index} className="bg-[var(--hexa-border-subtle)] border-[var(--hexa-border)]">
          <CardContent className="p-3">
            <div className="flex flex-wrap items-start gap-3">
              {/* Avatar skeleton */}
              <Skeleton className="h-8 w-8 rounded-full bg-[var(--hexa-border)]" />

              {/* Content skeleton */}
              <div className="flex-1 min-w-0 basis-36 space-y-2">
                <div className="flex items-center gap-2">
                  <Skeleton className="h-4 w-24 bg-[var(--hexa-border)]" />
                  <Skeleton className="h-3 w-12 bg-[var(--hexa-border)]" />
                </div>
                <Skeleton className="h-3 w-36 bg-[var(--hexa-border)]" />
                <div className="flex gap-2 mt-2">
                  <Skeleton className="h-4 w-12 rounded-full bg-[var(--hexa-border)]" />
                  <Skeleton className="h-4 w-12 rounded-full bg-[var(--hexa-border)]" />
                </div>
              </div>

              {/* Action buttons skeleton */}
              <div className="flex items-center gap-1">
                <Skeleton className="h-6 w-6 rounded-md bg-[var(--hexa-border)]" />
                <Skeleton className="h-6 w-6 rounded-md bg-[var(--hexa-border)]" />
                <Skeleton className="h-6 w-6 rounded-md bg-[var(--hexa-border)]" />
              </div>
            </div>
          </CardContent>
        </Card>
      ))}
    </>
  )
}
